import { NgModule } from '@angular/core';
import {
  MxEnumAsStringPipe,
  MxTableColoredRowPipe,
  MxEnumAsArrayPipe,
  MxDateFormatPipe,
  MxTableColoredCellPipe,
  MxTableHasFiltersPipe,
  MxDateAgoPipe,
  MxHtmlToTextPipe,
  MxFilterByPipe,
  MxFirstLetterOperationPipe,
  MxMenuRightsPipe,
} from '.';

export const PIPES: any[] = [
  MxEnumAsStringPipe,
  MxTableColoredRowPipe,
  MxEnumAsArrayPipe,
  MxDateFormatPipe,
  MxTableColoredCellPipe,
  MxTableHasFiltersPipe,
  MxDateAgoPipe,
  MxHtmlToTextPipe,
  MxFilterByPipe,
  MxFirstLetterOperationPipe,
  MxMenuRightsPipe,
];

@NgModule({
  imports: [],
  declarations: [...PIPES],
  exports: [...PIPES],
  providers: [...PIPES],
})
export class MxPipesModule {}
